import React from "react";

export default function BlogHeader() {
  return (
    <section id="blog-header" className="page-header">
      <h2>#ReadMore</h2>
      <p>Post your first Blog here</p>
    </section>
  );
}
